<template>
    <a-drawer placement="right" :closable="false" :visible="showDrawer" @close="close" width="70%"
        :style="{ transform: 'none' }">
        <a-spin v-if="loading" size="large" class="loading" />
        <div v-else>
            <div class="header">
                <div class="title">
                    课程详情
                </div>
                <div class="operation">
                    <a-button @click=goToClassroom><a-icon type="play-circle" />播放</a-button>
                    <a-button v-if="courseItem.controlUpdateButton" @click="editConfirm()">修改</a-button>
                    <a-button v-if="courseItem.status == '3' || courseItem.status == '2'"
                        @click="submit()">提交审核</a-button>
                </div>
                <a class="close-img" @click="close">
                    <img src="../../../../public/close.png" />
                </a>
            </div>
            <div class="info">
                <div class="pic">
                    <img :src="courseItem.coverUrl" v-if="courseItem.coverUrl && courseItem.coverUrl != 'undefined'">
                    <img src="../../../../public/gateway/course/defaultImg.png" v-else>
                </div>
                <div class="course-info">
                    <h2>
                        {{ courseItem.courseName }}
                        <template v-if="courseItem.status == 1">
                            <a-button type="primary" v-if="courseItem.selectStatus == '0'"
                                @click="addSelectCourse(true, courseItem)">加入选课</a-button>
                            <a-button v-else type="primary"
                                @click="addSelectCourse(false, courseItem)">移除选课</a-button>
                        </template>
                    </h2>
                    <div class="detail">
                        <div class="text">
                            <div class="line">
                                <div class="title">课时数</div>{{ courseItem.classHours }}节
                            </div>
                            <div class="line">
                                <div class="title">课程类型</div>{{ courseItem.cateFirstName }}课
                            </div>
                            <div class="line">
                                <div class="title">课程级别</div>{{ courseItem.courseLevel == 1 ? '初级班' :
                                    courseItem.courseLevel == 2 ? '中级班' : '高级班' }}
                            </div>
                            <div class="line">
                                <div class="title">上课周期</div>
                                <div>{{ courseItem.classWeeks | weekName }}</div>
                            </div>
                            <div class="line">
                                <div class="title">适用年级</div>
                                <div>{{ courseItem.gradeScope | gradeScopeFilter }}</div>
                            </div>
                            <div class="line">
                                <div class="title">可报名人数</div>{{ courseItem.lowerLimit }}~{{ courseItem.upperLimit }}人
                            </div>
                            <div class="line">
                                <div class="title">课程类目</div>
                                {{ courseItem.cateFirstName }}
                                {{ courseItem.cateSecondName ? '/ ' + courseItem.cateSecondName : '' }}
                                {{ courseItem.cateThirdName ? '/ ' + courseItem.cateThirdName : '' }}
                            </div>
                        </div>
                        <div>
                            <div class="price">
                                <div class="price-detail mb12">
                                    总价
                                    <span>¥{{ handlePrice(courseItem.totalPrice) }}</span>
                                </div>
                                <div class="price-detail mb12">
                                    课程
                                    <span>¥{{ handlePrice(courseItem.coursePrice) }}</span>
                                </div>
                                <div class="price-detail">
                                    <p>教材&nbsp;&nbsp;
                                        <span class="required" v-if="courseItem.textbookRequired == 1">(必选)</span>
                                    </p>
                                    <span>¥{{ handlePrice(courseItem.textbookPrice) }}</span>
                                </div>
                            </div>
                            <div class="line">
                                <div class="title">课程梯度</div>{{ courseItem.tagGradientName }}
                            </div>
                            <div class="line">
                                <div class="title">课程周期</div>{{ courseItem.tagCycleName }}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="课程详情">
                    <div class="tab-body">
                        <div class="course-detail" v-html="courseItem.intro" v-if="courseItem.intro"></div>
                        <div v-else>
                            <a-empty description="暂无课程详情" class="mt150"></a-empty>
                        </div>
                    </div>
                </a-tab-pane>
                <a-tab-pane key="2" tab="课程大纲">
                    <div class="tab-body">
                        <div v-if="courseItem.courseLesson && courseItem.courseLesson.length">
                            <div v-for="(item, index) in courseItem.courseLesson" :key="index">
                                <div slot="dot" class="box-list-dot"></div>
                                <div class="box-list-title">
                                    {{ index + 1 }}.{{ item.title }}
                                </div>
                                <div class="box-list-content">{{ item.content }}</div>
                            </div>
                        </div>
                        <div v-else>
                            <a-empty description="暂无课程大纲" class="mt150"></a-empty>
                        </div>
                    </div>
                </a-tab-pane>
                <a-tab-pane key="3" tab="联系方式">
                    <div class="tab-body">
                        <div class="title">
                            联系方式
                        </div>
                        <div class="contact">
                            <div class="label">课程方名称：</div>
                            {{ institutionInfo.institutionName }}
                        </div>
                        <div class="contact">
                            <div class="label">课程方种类：</div>
                            {{ institutionInfo.institutionType == 1 ? '社会企业' :
                                institutionInfo.institutionType == 2 ? '个人老师' :
                                    institutionInfo.institutionType == 3 ? '高校与协会' : '' }}
                        </div>
                        <div class="contact">
                            <div class="label">地区：</div>
                            {{ institutionInfo.province }}{{ institutionInfo.city }}{{ institutionInfo.district }}
                        </div>
                        <div class="contact">
                            <div class="label">详细地址：</div>
                            {{ institutionInfo.address }}
                        </div>
                        <div class="contact">
                            <div class="label">负责人姓名：</div>
                            {{ institutionInfo.masterName || '-' }}
                        </div>
                        <div class="contact">
                            <div class="label">负责人手机号：</div>
                            {{ institutionInfo.masterMobile || '-' }}
                        </div>
                    </div>
                </a-tab-pane>
                <a-tab-pane key="4" tab="审核详情">
                    <div class="tab-body">
                        <div class="in-item">
                            <div class="key">
                                审核状态
                                <span class="value ml30" :class="{
                                    'value-rejected': status == '2',
                                    'value-resolve': status == '1',
                                    'value-examine':
                                        status == '0' ||
                                        status == '4' ||
                                        status == '5' ||
                                        status == '3',
                                }">{{
                                    status == '0'
                                        ? '待审核'
                                        : status == '1'
                                            ? '审核通过'
                                            : status == '2'
                                                ? '审核不通过'
                                                : status == '3'
                                                    ? '待提交'
                                                    : status == '4'
                                                        ? '初审通过'
                                                        : '复审通过'
                                }}</span>
                            </div>
                            <div class="value">
                                <ul class="process">
                                    <li class="process-item" v-for="item in checkOperateLogArr" :key="item.id">
                                        <span class="operate">{{ item.operateLog }}</span>
                                        <span :class="[
                                            item.stateAfter == 1
                                                ? 'exa1'
                                                : item.stateAfter == 2
                                                    ? 'exa2'
                                                    : 'exa3',
                                        ]">
                                            {{ item.stateAfterText }}
                                        </span>
                                        <div class="comment" v-if="item.userComment">
                                            审核意见：{{ item.userComment }}
                                        </div>
                                        <div class="download-btn" v-if="item.attachmentUrl">
                                            <span>相关附件：{{ item.fileName }}</span>
                                            <a :href="rootUrl + item.attachmentUrl"
                                                :download="rootUrl + item.attachmentUrl" target="_blank">
                                                下载</a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </a-tab-pane>
                <a-tab-pane key="5" tab="开班列表">
                    <div class="tab-body">
                        <a-table :columns="classColumns" :data-source="classData" :pagination="classPagination" bordered
                            :rowKey="getRowKey" @change="classChange">
                            <template slot="startClassDate" slot-scope="text, record">
                                {{ text }} ~ {{ record.endClassDate }}
                            </template>
                        </a-table>
                    </div>
                </a-tab-pane>
            </a-tabs>
        </div>
    </a-drawer>
</template>

<script>
import course from '../../../api/course'
const classColumns = [
    {
        title: "班级名称",
        dataIndex: "className",
    },
    {
        title: "上课学校",
        dataIndex: "schoolName",
    },
    {
        title: "上限人数",
        dataIndex: "upperLimit",
    },

    {
        title: "报名人数",
        dataIndex: "applyCount",
    },
    {
        title: "报名率",
        dataIndex: "applyRate",
    },
    {
        title: "开班/结班时间",
        dataIndex: "startClassDate",
        scopedSlots: { customRender: "startClassDate" },
    },
];
export default {
    name: "CourseCenterDetail",
    props: {
        showDrawer: {
            type: Boolean,
            default: false,
        },
        courseItem: {
            type: Object,
        },
        courseNeedCheck: {
            type: Boolean
        }
    },
    data() {
        return {
            loading: true,
            status: -1,
            checkOperateLogArr: [],
            formDrawer: false,
            institutionInfo: {},
            classColumns,
            classData: [],
            classPagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                size: "small",
                showQuickJumper: true,
                showTotal: (total) => `共${total}条数据`
            },
            rootUrl: '', // 基地址
        };
    },
    created() {
        this.status = this.courseItem.status
        this.getData()
        this.getOpenClass()
        this.getHostUrl()
    },
    methods: {
        close() {
            this.$emit("update:showDrawer", false);
        },
        goToClassroom() {
            course.goToClassroom(this.courseItem.id).then(res => {
                if (res.target) {
                    window.open(res.target, 'courseId' + this.courseItem.courseId)
                }
            })
        },
        getHostUrl() {
          this.rootUrl = globalConfig.rootUrl + '/api/pcWeb/aliyun/getFile?url='
        },
        getOpenClass() {
            let params = {
                courseId: this.courseItem.id,
                currentPage: this.classPagination.current,
                pageSize: this.classPagination.pageSize
            }
            course.getOpenClass(params).then(res => {
                console.log(res, 'res')
                this.classData = res.data.records;
                this.classData.forEach(item => {
                    item.applyRate = item.applyCount ? (item.applyCount / item.upperLimit * 100).toFixed(1) + '%' : '0%'
                })
                this.classPagination.total = res.data.total;
            })
        },
        classChange(e) {
            this.classPagination.current = e.current;
            this.getOpenClass();
        },
        getData() {
            course.getCourseCenterDetail(this.courseItem.id).then(res => {
                if (res.data.courseInstitutionInfoDTO) {
                    this.institutionInfo = res.data.courseInstitutionInfoDTO
                } else {
                    this.institutionInfo = {}
                }
                this.checkOperateLogArr = res.data.checkOperateLogDTo.checkOperateLogDos
                this.loading = false
            }).catch(() => {
                setTimeout(() => {
                    this.close()
                }, 1000)
            })
        },
        // 修改前先校验
        editConfirm() {
            let _this = this;
            if (this.status == 1 && this.courseNeedCheck) {
                this.$confirm({
                    title: '确定要修改课程?',
                    content: '本课程“' + this.courseItem.courseName + '”当前是“审核通过”通过状态，如果您修改保存本课程，将会再次进入审核状态，审核通过之前学校不可选课不可开班。',
                    onOk() {
                        _this.editConfirm2nd();
                    },
                    onCancel() { },
                });
            } else {
                //不是审核，或不要求审核，只提示一次
                this.editConfirm2nd();
            }
        },
        editConfirm2nd() {
            let _this = this;
            if (this.courseItem.selectStatus == 1) //已选则需要提醒编辑影响已开班
                this.$confirm({
                    title: '确定要修改课程?',
                    content: '确认继续修改可能会导致目前使用本课程“已开班”的班级受到影响，请问继续修改本课程内容吗？',
                    onOk() {
                        _this.edit()
                    },
                    onCancel() { },
                });
            else {
                this.edit();//未选可直接编辑
            }
        },
        getRowKey(record, index) {
            return index;
        },
        edit() {
            this.$emit('edit', this.courseItem)
            this.$nextTick(() => {
                this.close()
            })
        },
        del() {
            let _this = this
            this.$confirm({
                title: '确定要删除吗?',
                okText: '确定',
                cancelText: '取消',
                content: '删除后，无法撤销',
                onOk() {
                    course.deleteCourse(_this.courseItem.id).then((res) => {
                        _this.$message.success('删除成功')
                        _this.close()
                        _this.$emit('refresh')
                    })
                },
            })
        },
        // 选课
        addSelectCourse(isAdd, value) {
            if (isAdd === true && value && value.totalPrice === -1) {
                this.$error({ title: '课程暂未定价，无法加入选课' })
                return
            }
            let req = {
                courseIds: value.id,
                schoolId: this.$store.getters.userInfo.schoolId,
                selectStatus: isAdd ? '1' : '0', //选课状态：0-未选（移除），1-已选（选课
            }
            course.selectOrRemove(req).then((res) => {
                if (isAdd) {
                    this.courseItem.selectStatus = '1'
                    this.$message.success('选课成功')
                } else if (!isAdd) {
                    this.courseItem.selectStatus = '0'
                    this.$message.success('移除成功')
                }
                this.$emit('refresh')
            })
        },
        // 提交审核
        submit() {
            course.submitCourse({ courseIds: this.courseItem.id }).then((res) => {
                this.$message.success('提交成功')
            })
        },
        handlePrice(price) {
            return (price / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
    }
};
</script>

<style lang="less" scoped>
::v-deep .ant-drawer-body {
    font-family: PingFangSC, PingFang SC;
    padding: 0;
}

::v-deep .ant-divider {
    margin: 10px 0;
    background-color: #f0f3fb !important;
}

.close-img {
    position: absolute;
    top: 20px;
    right: 26px;
}

.loading {
    height: 100vh;
    width: 100%;
    padding-top: 35%;
}

.header {
    position: sticky;
    top: 0;
    z-index: 999;
    background: #F1F6FC;
    height: 64px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 70px 0 24px;

    button {
        color: #333;
        margin-left: 12px;
    }

    .title {
        font-weight: 600;
        font-size: 16px;
        color: #1B1D26;
    }
}

.info {
    display: flex;
    padding: 43px 70px 20px 25px;
    width: 100%;

    .pic {
        width: 292px;
        height: 164px;
        margin-right: 25px;

        img {
            width: 292px;
            height: 164px;
            object-fit: cover;
            border-radius: 10px;
        }
    }

    .course-info {
        width: 100%;

        h2 {
            font-weight: 600;
            font-size: 22px;
            color: #333333;
            line-height: 30px;
            margin-bottom: 28px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            button {
                z-index: 0;
            }
        }

        .detail {
            display: flex;

            .text {
                margin-right: 50px;

            }

            .line {
                display: flex;
                margin-bottom: 12px;
                font-size: 14px;
                line-height: 14px;
                font-weight: 600;
                color: #171A1D;

                .title {
                    color: rgba(23, 26, 29, 0.6);
                    font-weight: normal;
                    width: 86px;
                }
            }

            .price {
                width: 193px;
                margin-bottom: 22px;
                padding: 12px 16px;
                background: #F7FAFF;
                border-radius: 6px;

                .price-detail {
                    display: flex;
                    justify-content: space-between;
                    font-weight: 300;
                    font-size: 14px;
                    color: #3C454C;
                    line-height: 20px;

                    span {
                        font-weight: 500;
                        color: #3C454C;
                    }

                    .required {
                        color: red;
                    }
                }
            }
        }
    }
}

.mb12 {
    margin-bottom: 12px;
}

::v-deep .ant-tabs-bar {
    border-bottom: none;
    position: relative;

    .ant-tabs-tab {
        padding-bottom: 16px;
    }
}

::v-deep .ant-tabs-nav-wrap:before {
    content: "";
    position: absolute;
    top: 44px;
    left: 0;
    height: 4px;
    width: 100%;
    z-index: 0;
    background-color: #F1F6FC;
}

::v-deep .ant-tabs-ink-bar {
    height: 4px;
    margin-left: 16px;
    width: 56px !important;
    background: #3198FF;
    z-index: 1;
}

::v-deep .ant-tabs-tab-active:after {
    content: "";
    position: absolute;
    top: 44px;
    left: 0;
    height: 4px;
    width: 100%;
    background-color: #F1F6FC;
}

.tab-body {
    padding: 0 24px 24px;

    .title {
        margin-top: 20px;
        color: rgba(0, 0, 0, 0.85);
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 10px;
    }

    .contact {
        display: flex;
        font-size: 16px;

        .label {
            margin-bottom: 5px;
            width: 120px;
            text-align: right;
        }
    }
}

.box-list-dot {
    width: 12px;
    height: 12px;
    background-color: #35c794;
    border-radius: 50px;
    margin-top: 8px;
}

.box-list-title {
    font-size: 22px;
}

.box-list-content {
    width: 100%;
    padding: 20px;
    background-color: #f4f7fd;
    margin-top: 16px;
}

.value {
    vertical-align: top;
    // color: $normal-color-dark;
    padding-left: 6px;
    display: inline-block;
    padding-right: 16px;
    text-align: left;
    width: calc(100% - 170px);
}

.ml30 {
    margin-left: 30px;
}

.in-item {
    overflow-y: auto;
    overflow-x: hidden;
    margin-top: 20px;
    padding-bottom: 10px;

    >.key {
        color: rgba(0, 0, 0, 0.85);
        font-size: 20px;
        font-weight: 600;
    }

    >.value {
        font-size: 14px;
        color: #606266;
        margin-top: 19px;
        margin-left: 74px;
    }

    .process {
        width: 100%;
        height: 100%;
        overflow: auto;
        margin-left: 52px;
        margin-top: 19px;

        &-item {
            margin-bottom: 10px;

            .operate {
                color: #c0c4cc;
                margin-left: 26px;
            }

            // 审核意见
            .comment {
                color: #333;
                margin-left: 30px;
            }

            // 下载附件
            .download-btn {
                color: #333;
                margin-left: 30px;

                a {
                    margin-left: 20px;
                }
            }
        }

        li:before {
            content: '';
            width: 4px;
            height: 4px;
            display: inline-block;
            border-radius: 50%;
            background: #bdbdbd;
            vertical-align: middle;
        }
    }

    // 审核通过颜色
    .exa1 {
        color: #19ca3c;
    }

    // 审核驳回颜色
    .exa2 {
        color: #f95050;
    }

    // 初审、复审颜色
    .exa3 {
        color: #ffa91f;
    }
}

.value-resolve {
    color: #37c847 !important;
}

.value-rejected {
    color: #f54d15 !important;
}

.value-examine {
    color: #ffa91f !important;
}

.mt150 {
    margin-top: 150px;
    ;
}

.course-detail {
    ::v-deep p {
        img {
            max-width: 100%;
        }
    }
}
</style>